<template>
  <lu-vbox lu-flex class='tab-container' style='height: 100%'>
    <Spinner ref='spinner' style='z-index:60000 !important'/>

    <el-form style='flex: 1 1 auto; display: flex;' ref="form" :model='form' lu-flex label-width="250px" >

    <el-tabs class='categoryTabs' v-model="activeName" tab-position="left"  type="border-card" style="margin: 20px;">
      <el-tab-pane v-for='(env, idx) in brokerListSelect' :key='idx' :label="env.label" :name="env.label" style='padding: 10px;'>
        <lu-vbox lu-flex>
          <el-tabs class='subTabs' v-model='activeTab' tab-position='top' type='border-card'>
            <el-tab-pane :label='$t("Groups")' name='groups' id='elTree'>
              <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'>

                  <lu-vbox style='margin-top:20px;' class='config-container vpad-in-5'>
                    <lu-hbox lu-click lu-vcenter class='title pad-in-5' @click='toggleSearch'>
                      <FontIcon type='material-icons' name='keyboard_arrow_right' class='icon' size='xsmall' :class="{'isActive': searchExpanded}"/>
                      <lu-item >{{ $t('Search & Replace') }}</lu-item>
                    </lu-hbox>

                    <lu-vbox v-if='searchExpanded'>
                      <lu-hbox>
                        <lu-vbox>
                          <lu-item>
                            <el-form-item style='width: 400px;' :label="$t('Include intruments')" label-width="180px">
                                <el-checkbox v-model="form.includeChild"></el-checkbox>
                            </el-form-item>
                          </lu-item>
                          <lu-item>
                              <el-form-item style='width: 400px;' label="Group name" label-width="180px">
                                <el-input v-model='form.searchGroupName' clearable />
                              </el-form-item>
                          </lu-item>

                          <lu-hbox>
                            <lu-item>
                              <el-form-item style='width: 400px;' label="Category name" label-width="180px">
                                <el-select clearable v-model='form.searchCategory' >
                                  <el-option v-for='cat in form.categoryList' :key='cat.category' :value='cat.category' :label='cat.categoryName' />
                                </el-select>
                              </el-form-item>
                            </lu-item>
                            <lu-item>
                              <el-form-item style='width: 400px;' prop='replaceCategory' label="Target Category name" label-width="200px">
                                <el-select clearable v-model='form.replaceCategory' >
                                  <el-option v-for='cat in form.categoryList' :key='cat.category' :value='cat.category' :label='cat.categoryName' />
                                </el-select>
                              </el-form-item>
                            </lu-item>
                          </lu-hbox>
                        </lu-vbox>
                      </lu-hbox>
                      <lu-hbox slu-hcenter class='msg pad-in-5'>
                          <lu-item lu-vcenter class='msgLeft error' v-if="form.searchGroupName !== null || form.searchCategory !== null || form.replaceCategory !== null">{{ $t('Found items')}} : {{ total }}</lu-item>
                          <lu-hbox lu-flex lu-hcenter class='msgRight pad-in-5'>
                            <lu-item v-if='canReplace()'><el-button class="button" icon="el-icon-check"  @click.stop='confirmReplace'>{{ $t('action.confirm') }}</el-button></lu-item>
                            <lu-item><el-button class="button" icon="el-icon-close"  @click.stop="searchReset">{{ $t('action.reset') }}</el-button></lu-item>
                            <lu-item><el-button class="button" icon="el-icon-close"  @click.stop="searchClose">{{ $t('action.close') }}</el-button></lu-item>
                          </lu-hbox>

                      </lu-hbox>
                    </lu-vbox>
                  </lu-vbox>

                <el-tree
                  :data="groupData"
                  style='margin:20px;'
                  class='lu-flex menu-tree'
                  :indent='20'
                  :expand-on-click-node="false"
                  :render-after-expand="true"
                  :props="defaultProps"
                >

                  <span class='menu-tree-row' slot-scope="{ node, data }">
                    <template>
                      <span class='menu-tree-node-label'>
                        <span>{{ data.label}} </span>
                      </span>

                      <span class='menu-tree-node-label' v-if='data.newCategory'>
                        <span style='text-decoration: line-through;'>{{ data.categoryName }}</span>
                      </span>

                      <span class='menu-tree-node-content' @click.stop >
                        <lu-hbox style='heigth: 40px;'>
                          <el-select  v-bind:value='getVisualCategoryPlatform(data)'
                                      v-bind:class='getStyleCategoryPlatform(data)'
                                      @change="changeCategoryPlatform($event,data)"
                                      :clearable='canClear(data)' >

                            <el-option v-for='cat in form.categoryList' :key='cat.category' :value='cat.category' :label='cat.categoryName' />

                          </el-select>
                          <el-button v-if="data.isEdit" class="icon" size="mini" icon='el-icon-check positive' @click.stop='saveCategoryPlatform(data, true)' />
                          <el-button v-if="data.isEdit" class="icon" size="mini" icon='el-icon-close' @click.stop='cancelCategorPlatformChanges(data)' />
                        </lu-hbox>
                      </span>
                    </template>
                  </span>
                </el-tree>
              </lu-scroll-area>
            </el-tab-pane>

            <el-tab-pane :label='$t("Categories")' name='categories'>

                <template v-if='newCategory'>
                  <lu-vbox class='config-container vpad-in-5'>
                    <lu-item class='title'>{{ $t('New category')}} </lu-item>
                    <lu-hbox lu-flex lu-flex-wrap>
                      <lu-item>
                        <el-form-item style='width: 400px;' label="Name" prop="categoryName" required :rules='ruleCategoryName'>
                          <el-input v-model='form.categoryName' />
                        </el-form-item>
                      </lu-item>
                    </lu-hbox>

                    <lu-hbox lu-hcenter class='pad-in-5'>
                        <lu-item><el-button class="button" icon="el-icon-check"  @click.stop='createCategory'>{{ $t('action.save') }}</el-button></lu-item>
                        <lu-item><el-button class="button" icon="el-icon-close"  @click.stop='cancelCreateCategory'>{{ $t('action.cancel') }}</el-button></lu-item>
                    </lu-hbox>
                  </lu-vbox>
                </template>

                <template v-else>
                  <lu-item lu-click lu-right style='padding: 15px 0' v-if='!newCategory'>
                    <el-button size="mini" icon="el-icon-plus icon success"  @click='handleNewCategory' >{{ $t('Add category') }}</el-button>
                  </lu-item>
                </template>

                <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'>

                    <table class='groupTable'>
                      <tr>
                        <th width='100px' class='colTitle'>{{ $t('Category ID') }}</th>
                        <th width='300px' class='colTitle'>{{ $t('Category Name') }}</th>
                        <th />
                      </tr>
                      <tr style='height: 60px;line-height: 40px;' v-for='(cat, idx) in form.categoryList' :key='idx'>
                        <td width='100px'>{{ cat.category }}</td>
                        <td width='300px;'>
                          <template v-if='cat.isEdit'>
                            <el-form-item label-width="0" label="" required :prop='"categoryList["+idx+"].categoryName"' :rules='ruleCategoryName'>
                              <el-input v-model='cat.categoryName' />
                            </el-form-item>
                          </template>
                          <template v-else>
                            {{ cat.categoryName }}
                          </template>
                        </td>
                        <td width='50px;'>
                          <lu-hbox lu-hcenter class='pad-in-5'>
                            <template  v-if='cat.isEdit'>
                              <lu-item><el-button class="icon" size="mini" :icon="cat.isSave ? 'el-icon-loading positive'  : 'el-icon-check positive'"  @click.stop='saveCategory(cat)' /></lu-item>
                              <lu-item><el-button class="icon" size="mini" icon="el-icon-close error"     @click.stop='cancelCategory(cat)' /></lu-item>
                            </template>
                            <lu-item v-if='!cat.isEdit'><el-button class="icon" size="mini" icon="el-icon-edit positive"   @click.stop='editCategory(cat)' /></lu-item>
                            <lu-item v-if='!cat.isEdit'><el-button class="icon" size="mini" icon="el-icon-delete error"   @click.stop='deleteCategory(cat)' /></lu-item>
                          </lu-hbox>
                        </td>
                      </tr>
                    </table>
                </lu-scroll-area>


            </el-tab-pane>
            <el-tab-pane :label='$t("NOP Range")' name='nopRange'>
                <lu-item lu-click lu-right style='padding: 15px 0; margin-left: auto'>
                  <el-button class="button" icon="el-icon-check"  @click.stop='saveNopRanges'>{{ $t('action.save') }}</el-button>
                </lu-item>
                <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'>

                    <table class='nopRangeTable'>
                      <tr>
                        <th width='100px' class='colTitle'>{{ $t('Level') }}</th>
                        <th width='300px' class='colTitle'>{{ $t('NOP') }}</th>
                      </tr>
                      <tr style='height: 60px;line-height: 40px;' v-for='(cat, idx) in form.nopRangeList' :key='idx'>
                        <td width='100px;' style="vertical-align: middle">
                          <template>
                            <div class="levelNopRange" :style="getLevelStyle(idx)"></div>
                          </template>
                        </td>
                        <td width='300px;'>
                          <template v-if="idx===0">
                            <el-form-item label-width="0" label="" :prop='"nopRangeList["+idx+"].nop"' style="margin: auto;">
                              <lu-hbox lu-vcenter lu-hcenter lu-flex>
                                <el-input-number size="small" v-model='cat.nop' :min="getMinValue(idx)" :max="getMaxValue(idx)" />
                                <span style="margin-left: 15px;">M USD</span>
                              </lu-hbox>
                            </el-form-item>
                          </template>
                          <template v-if="idx!==0 && idx!==form.nopRangeList.length - 1 ">
                            <el-form-item label-width="0" label="" :prop='"nopRangeList["+idx+"].nop"' style="margin: auto;" >
                              <lu-hbox lu-vcenter lu-hcenter lu-flex>
                                <el-input-number size="small" v-model='cat.nop' :min="getMinValue(idx)" :max="getMaxValue(idx)" />
                                <span style="margin-left: 15px;">M USD</span>
                              </lu-hbox>
                            </el-form-item>
                          </template>
                          <template v-if="idx===form.nopRangeList.length - 1 && form.nopRangeList.length>1">
                            <el-form-item label-width="0" label="" :prop='"nopRangeList["+idx+"].nop"' style="margin: auto;" >
                              <lu-hbox lu-vcenter lu-hcenter lu-flex>
                                <el-input-number size="small" v-model='cat.nop' :min="getMinValue(idx)" />
                                <span style="margin-left: 15px;">M USD</span>
                              </lu-hbox>
                            </el-form-item>
                          </template>
                        </td>
                      </tr>
                    </table>
                </lu-scroll-area>
            </el-tab-pane>
          </el-tabs>
        </lu-vbox>
      </el-tab-pane>
    </el-tabs>
    </el-form>

  </lu-vbox>
</template>

<script>
import { LuHbox, LuItem, LuVbox, LuScrollArea } from 'lusis-ui'
import { mapGetters } from 'vuex'
import FontIcon from '@/components/FontIcon'
import Spinner from '@/components/Spinner'

export default {
  name: 'CategoryConfig',
  components: { Spinner, FontIcon, LuHbox, LuItem, LuVbox, LuScrollArea },
  data () {
    return {
      activeName: null,
      newCategory: false,
      isEdit: false,
      activeTab: 'groups',
      groupList: [],
      // localBrokerList: [],
      forceLoading: false,
      tree: [],
      groupNameMap: {},
      searchExpanded: true,
      // total: 0,
      levelColor: [
        '#66FF66', // level 0
        '#FFCC66', // level 1
        '#FF9966', // level 2
        '#FF5050' // level 3
      ],
      form: {
        searchGroupName: null,
        searchCategory: null,
        includeChild: false,
        categoryName: null,
        replaceCategory: null,
        categoryList: [],
        nopRangeList: []
      },
      ruleCategoryName: [
        { validator: this.validateCategory },
        { required: true, message: 'Please input new category name', trigger: ['blur', 'change'] }
      ],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  created () {
    this.activeName = (this.brokerListSelect && this.brokerListSelect.length) ? this.brokerListSelect[0].label : null
  },
  watch: {
    activeName () {
      this.newCategory = false
      this.activeTab = 'groups'
      this.searchReset()
    },
    'form.replaceCategory' () {
      if (this.form.searchGroupName !== null || this.form.searchCategory !== null) this.updateGroupData()
    }
  },
  methods: {
    toggleSearch () {
      this.searchExpanded = !this.searchExpanded
    },
    canReplace () {
      return this.total && this.form.replaceCategory !== null && (this.form.searchGroupName !== null || this.form.searchCategory)
    },
    updateGroupData () {
      // this.total = 0
      this.groupData.forEach(item => {
        item.newCategory = this.form.replaceCategory ? this.form.replaceCategory : null
        if (item.treeNode) item.treeNode.newCategory = item.newCategory
        // this.total++
        if (item.children) {
          item.children.forEach(child => {
            child.newCategory = this.form.replaceCategory ? this.form.replaceCategory : null
            if (child.treeNode) child.treeNode.newCategory = child.newCategory
            // this.total++
          })
        }
      })
    },
    confirmReplace () {
      this.$confirm('Found ' + this.total + ' items. This will permanently change the category. Continue?', 'Warning', {
        confirmButtonText: this.$t('OK'),
        cancelButtonText: this.$t('Cancel'),
        type: 'warning'
      }).then(() => {
        this.$refs.spinner.show()
        let promiseList = []
        this.groupData.forEach(item => {
          if (item.newCategory) promiseList.push(this.saveCategoryPlatform(item, false))
          item.children.forEach(child => {
            if (child.newCategory) promiseList.push(this.saveCategoryPlatform(child, false))
          })
        })
        Promise.all(promiseList).then(() => {
          this.$message({
            message: 'Category config has been changed successfully',
            type: 'success'
          })
          this.form.replaceCategory = null
          this.$refs.spinner.hide()

        }).catch(() => {
          this.form.replaceCategory = null
          this.$refs.spinner.hide()
        })
      })
    },
    searchReset () {
      this.groupData.forEach(g => {
        g.newCategory = null
        if (g.treeNode) g.treeNode.newCategory = null
        g.children.forEach(c => {
          c.newCategory = null
          if (c.treeNode) c.treeNode.newCategory = null
        })
      })
      this.form.searchGroupName = null
      this.form.searchCategory = null
      this.form.replaceCategory = null
    },
    searchClose () {
      this.searchExpanded = false
      this.searchReset()
    },
    handleNewCategory () {
      this.newCategory = true
      this.form.categoryName = null
    },
    validateCategory (rule, value, cb) {
      if (value !== '') {
        let arr = /^categoryList\[([0-9]+)\]/.exec(rule.field)
        let me = -1
        if (arr) me = this.form.categoryList[parseInt(arr[1])].category
        let idx = this.form.categoryList.findIndex(b => b.categoryName === value && b.category !== me)
        if (idx !== -1) {
          cb(new Error(this.$t('This categoryName already exists')))
          return
        }
      }
      cb()
    },
    cancelCreateCategory () {
      this.newCategory = false
      this.form.categoryName = null
    },
    cancelCategorPlatformChanges (data) {
      data.newCategory = null
      data.isEdit = false
    },
    changeCategoryPlatform (newId, data) {
      data.newCategory = newId
      if (data.treeNode) data.treeNode.newCategory = newId
      this.saveCategoryPlatform(data, true)
    },
    canClear (data) {
      return !this.isEmptyCategory(data)
    },
    isEmptyCategory(data,key='category') {
      return data[key] === null || data[key]=== undefined || data[key] === ""
    },
    getVisualCategoryPlatform (data) {
      if (data.instrumentName && !data.category) {
        let groupData = this.groupNameMap[data.groupName]
        if (groupData) return groupData.newCategory ? groupData.newCategory : groupData.category
      }
      return data.newCategory ? data.newCategory : data.category
    },
    getStyleCategoryPlatform (data) {
      if (data.instrumentName && !data.category)
        return "elementInputInnerDisabled"
      return "elementInputInnerEnabled"
    },
    createCategory () {
      this.$nextTick().then(() => {
        this.$refs.form.validate(valid => {
          if (valid) {
            let cond = {
              functionId: 'newCategory',
              parameterList: [{
                paramName: 'categoryName',
                paramValue: this.form.categoryName
              }]
            }

            this.sendTango(cond).then(() => {
              this.$message({
                message: 'Category config has been changed successfully',
                type: 'success'
              })
              this.newCategory = false
              this.form.categoryName = null
              this.forceLoading = true
            })
          }
        })
      })
    },
    saveCategoryPlatform (data, isSingle) {
      let cond = {
        functionId: 'setCategoryPlatform',
        parameterList: []
      }

      cond.parameterList.push(
        { paramName: 'platform', paramValue: this.activeName },
        { paramName: 'category', paramValue: data.newCategory },
        {
          paramName: data.instrumentName ? 'instrumentName' : 'groupName',
          paramValue: data.instrumentName ? data.instrumentName : data.groupName
        }
      )

      return this.sendCategoryPlatformTango(cond).then(() => {
        if (data.treeNode) {
          data.treeNode.category = data.newCategory
          data.treeNode.newCategory = null
        }
        data.category = data.newCategory
        data.newCategory = null
        if (isSingle) {
          this.$message({
            message: 'Category config has been changed successfully',
            type: 'success'
          })
        }
      }).catch(() => {
        data.newCategory = null
        if (data.treeNode) data.treeNode.newCategory = null
      })
    },
    editCategory (cat) {
      cat.isEdit = true
    },
    cancelCategory (cat) {
      cat.categoryName = cat.originName
      cat.isEdit = false
    },
    saveCategory (cat) {
      this.$nextTick().then(() => {
        this.$refs.form.validate(valid => {
          if (valid) {
            cat.isSave = true
            let cond = {
              functionId: 'setCategory',
              parameterList: [{
                paramName: 'category',
                paramValue: cat.category
              },
              {
                paramName: 'categoryName',
                paramValue: cat.categoryName
              }]
            }
            this.sendTango(cond).then(() => {
              this.$message({
                message: 'Category config has been changed successfully',
                type: 'success'
              })
              cat.isSave = false
            })
          }
        })
      })
    },
    deleteCategory: function (cat) {
      this.$nextTick().then(() => {
        this.$confirm('This will permanently delete the category. Continue ?', 'Warning', {
          confirmButtonText: this.$t('OK'),
          cancelButtonText: this.$t('Cancel'),
          type: 'warning'
        }).then(() => {

          let cond = {
            functionId: 'removeCategory',
            parameterList: [{
              paramName: 'category',
              paramValue: cat.category
            }]
          }
          this.sendTango(cond).then(() => {
            this.$message({
              message: 'Category config has been removed successfully',
              type: 'success'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          })
        })
      })
    },
    sendTango (cond) {
      return this.$tango.getCategoryConfig(cond).then(rep => {
        if (rep.resultCode !== 0) {
          throw new Error('ERROR : Category Config')
        } else {
          this.groupList = []
          this.form.categoryList = []
          if (rep.categoryList && rep.categoryList.length) {
            this.form.categoryList = rep.categoryList.map(item => {
              item.originName = item.categoryName
              item.isEdit = false
              item.isSave = false
              return item
            })
          }
        }
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err)
      })
    },
    sendCategoryPlatformTango (cond) {
      return this.$tango.getCategoryPlatform(cond).then(rep => {
        if (rep.resultCode !== 0) {
          throw new Error('ERROR : Category Platform Config')
        }
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err)
      })
    },
    getCategoryPlatform (cond) {
      return this.$tango.getCategoryPlatform(cond).then(rep => {
        if (rep.resultCode !== 0) {
          throw new Error('ERROR : Category Config')
        } else {
          this.tree = []
          this.groupNameMap = {}

          if (rep.categoryList && rep.categoryList.length) {
            rep.categoryList.forEach(cat => {
              if (cat) {
                let node = {
                  label: cat.groupName,
                  groupName: cat.groupName,
                  category: cat.category,
                  categoryName: cat.categoryName,
                  children: [],
                  newCategory: null
                }

                if (cat.instrumentList && cat.instrumentList.length) {
                  cat.instrumentList.forEach(ins => {
                    if (ins) {
                      let childNode = {
                        label: ins.instrumentName,
                        instrumentName: ins.instrumentName,
                        category: ins.category,
                        categoryName: ins.categoryName,
                        groupName: cat.groupName,
                        newCategory: null
                      }
                      node.children.push(childNode)
                    }
                  })
                }
                this.tree.push(node)
                this.groupNameMap[cat.groupName] = node
              }
            })
          }
        }
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err)
      })
    },
    getNOPRanges () {
      return this.$tango.getFunctionData({functionId: 'getNOPRanges'}).then(rep => {
        if (rep.resultCode !== 0) {
          throw new Error('ERROR : NOP Ranges Config')
        } else {
          this.form.nopRangeList = []
          if (rep.categoryList && rep.categoryList.length) {
            this.form.nopRangeList = rep.categoryList
          }
        }
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err)
      })
    },
    saveNopRanges () {
      this.$nextTick().then(() => {
        this.$refs.form.validate(valid => {
          if (valid) {
            let cond = {
              functionId: 'setNOPRanges',
              categoryList: this.form.nopRangeList
            }

            this.$tango.getFunctionData(cond).then(rep => {
              if (rep.resultCode !== 0) {
                throw new Error('ERROR : NOP Ranges Config')
              } else {
                this.$message({
                  message: 'NOP Ranges config has been changed successfully',
                  type: 'success'
                })
                this.getNOPRanges()
              }
            }).catch(err => {
              // eslint-disable-next-line no-console
              console.log(err)
            })
          }
        })
      })
    },
    clone: function (data) {
      if (data === null) return null
      if (data === undefined) return undefined
      if (Array.isArray(data)) {
        let ret = []
        for (let i = 0; i < data.length; i++) {
          this.$set(ret, i, this.clone(data[i]))
        }
        return ret
      }
      else if (typeof data === 'object') {
        let ret = {}
        for (let k in data) {
          this.$set(ret, k, this.clone(data[k]))
        }
        return ret
      }
      else return data
    },
    matchId: function (field, value) {
      return (field && value) ? field === value : value ? false : true
    },
    matchStr: function (field, value) {
      return (field && value) ? field.toLowerCase().includes(value.toLowerCase()) : value ? false : true
    },
    getLevelStyle (level) {
      if (this.levelColor[level]) {
        return {
            'background-color': this.levelColor[level]
        }
      }
      return ''
    },
    getMinValue: function (level) {
        if (level === 0) {
          return 0
        } else if (this.form.nopRangeList && level < this.form.nopRangeList.length) {
          if (this.form.nopRangeList[level-1]) {
            return parseFloat(this.form.nopRangeList[level-1].nop) + 1
          }
        }
    },
    getMaxValue: function (level) {
      if (this.form.nopRangeList && level < this.form.nopRangeList.length - 1) {
        if (this.form.nopRangeList[level+1]) {
          return parseFloat(this.form.nopRangeList[level+1].nop) - 1
        }
      }

    }
  },
  computed: {
    ...mapGetters([ 'brokerList' ]),
    groupData () {
      // this.total = 0
      if (!this.form.searchGroupName && !this.form.searchCategory) return this.tree
      let s = []
      this.tree.forEach(item => {
        if (this.matchStr(item.groupName, this.form.searchGroupName) && this.matchId(item.category, this.form.searchCategory)) {
          let group = this.clone(item)
          // this.total++
          group.children = item.children.filter(child => this.matchStr(child.instrumentName, this.form.searchGroupName) && this.matchId(child.category, this.form.searchCategory)).map(c => {
            let child = this.clone(c)
            child.treeNode = c
            return child
          })
          // this.total += group.children.length
          group.treeNode = item
          s.push(group)
        }
        else if (item.children && this.form.includeChild) {
          let arr = item.children.filter(child => {
            if (this.matchStr(child.instrumentName, this.form.searchGroupName) && this.matchId(child.category, this.form.searchCategory)) {
              return child
            }
          })
          if (arr.length) {
           let result = this.clone(item)
           result.children = arr
           result.treeNode = item
          //  this.total += arr.length
           s.push(result)
          }
        }
      })
      return s
    },
    total () {
      let currentValue = 0
      this.groupData.forEach(item => {
        if (item) {
          currentValue++
          if (item.children && item.children.length) {
            currentValue += item.children.length
          }
        }
      })
      return currentValue
    },
    // brokerListSelect: {
    //   get: function () {
    //     this.brokerList.forEach(b2 => {
    //       b2.brokerList.forEach(b => {
    //         if (b.status === 1 && this.$acl.isAllowedBroker(b.label)) {
    //           this.localBrokerList.push({
    //             functionId: b.functionId,
    //             label: b.label,
    //             isAllowed: false
    //           })
    //         }
    //       })
    //     })
    //     return this.localBrokerList
    //   },
    //   set: function (force) {
    //     this.localBrokerList.forEach(b => b.isAllowed = force)
    //   }
    // }
    brokerListSelect () {
      let localBrokerList = []
      this.brokerList.forEach(b2 => {
        b2.brokerList.forEach(b => {
          if (b.status === 1 && this.$acl.isAllowedBroker(b.label)) {
            localBrokerList.push({
              functionId: b.functionId,
              label: b.label,
              isAllowed: false
            })
          }
        })
      })
      return localBrokerList
    }
  },
  asyncComputed: {
    categoryConfig: {
      get () {
        return this.sendTango({functionId: 'getCategoryList'})
      },
      default: {},
    },
    categoryPlatformConfig: {
      get () {
        let cond = {
          functionId: 'getCategoryPlatform',
          parameterList: [{
            paramName: 'platform',
            paramValue: this.activeName
          }]
        }

        return this.getCategoryPlatform(cond)
      },
      default: {},
      shouldUpdate () {
        return (this.activeName !== undefined && this.activeName !== null)
      }
    },
    nopRangeConfig: {
      get () {
        return this.getNOPRanges()
      },
      default: {},
    },
  }
}
</script>

<style lang='scss'>
.tab-container {
  .el-tree-node__content {
    height: 45px;

    .el-input__inner {
      height: 30px;
      padding: 0 10px;
    }
  }
}
/* .el-tree-node:focus {
  outline-color: transparent !important;
} */
.categoryTabs.el-tabs--left {
  flex: 1 1 auto;
  display: flex;
  flex-direction: row;
}
.categoryTabs .subTabs.el-tabs--top {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}

.categoryTabs.el-tabs--left .el-tabs__item.is-left {
  border: solid 1px transparent !important;
}
.categoryTabs.el-tabs--left .el-tabs__content {
  /* background: black; */
  padding-left: 10px;
  flex: 1 1 auto;
}
.categoryTabs .subTabs.el-tabs--top .el-tabs__content {
  padding: 10px;
}
.categoryTabs.el-tabs--left .el-tabs__header.is-left {
  margin-right: 0px;
  border-right: solid 1px transparent !important;
}
.categoryTabs .el-tab-pane {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: 100%;
}
.groupTable th, .categoryTable th, .groupTable td, .categoryTable td, .nopRangeTable th, .nopRangeTable td {
  padding: 10px 5px;
}

.groupTable .colTitle,
.categoryTable .colTitle, .nopRangeTable .colTitle {
  font-size: 1.2em;
}

.newCategory-container {
  padding: 20px 10px;
  margin: 20px 0;
  border-radius: 5px;
}

.msg {
  .msgLeft {
    position: absolute;
    left: 30px;
    margin-top: 20px;
  }

  .msgRight {
  }
}

.levelNopRange {
  border: solid white 1px;
  padding: 0px;
  height: 32px;
  width: 40px;
  vertical-align: middle;
  margin: auto;
}

</style>

